export default {
  // 获取定位
  getLocation ({ commit }) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      GlobalPosition({ type: 'h5' }, (data) => {
        commit('setState', ['locationProvince', !data.status ? { sn: data.data.province.id, name: data.data.province.name } : -1])
        commit('setState', ['locationCity', !data.status ? { sn: data.data.city.id, name: data.data.city.name } : -1])
        resolve()
      })
    })
  }
}
